import { PatientDiscountFormOrganism } from '../patient-discount-form';
import Head from 'next/head';
import { useEffect } from 'react';
import { unloadMentionMe, useResponsiveQuery } from '../../../utils';
import { ResponsiveSizes } from '../../../enums';

export const PatientActionsOrganism = () => {
  useEffect(() => () => unloadMentionMe(), []);

  const isBreakpoint = useResponsiveQuery(ResponsiveSizes.CHECKOUT_DESKTOP);

  return (
    <div data-cy="checkout-actions-organism">
      {isBreakpoint && (
        <Head>
          <script
            src={`https://tag.mention-me.com/api/v2/refereefind/mmd272a8d2?implementation=link&situation=${
              isBreakpoint ? 'checkoutdesktop' : 'checkoutmob'
            }&locale=en_US`}
            async
          />
        </Head>
      )}
      <div className="w-11/12 lg:w-full mx-auto">
        <div className="mb-3 ">
          <PatientDiscountFormOrganism />
        </div>

        <a className="uppercase underline text-waldo-tangerine font-waldo-sans text-base transform transition-transform hover:-translate-y-1">
          <div id="mmWrapperDESK" className="mmWrapper hidden xl:block" />
          <div id="mmWrapperMOB" className="mmWrapper block xl:hidden" />
        </a>
      </div>
    </div>
  );
};
